export default "__VITE_ASSET__05xuvFlN__"